import React from 'react'
import { Nav, TabContent } from 'reactstrap'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import MergeContainer from 'containers/css-admin/merge/MergeContainer'
import MergeSiteContainer from 'containers/css-admin/mergeSite/MergeSiteContainer'
import PacingContainer from 'containers/css-admin/pacing/PacingContainer'
import SSOToolContainer from 'containers/css-admin/sso-tool/SSOToolContainer'
import BulkAssignLayout from 'containers/css-admin/bulkAssign'
import SitePreferencesContainer from 'containers/css-admin/sitePreferences/SitePreferencesContainer'
import ExternalSiteMappingContainer from 'containers/css-admin/externalSiteMapping'
import AdminNavBarItem from 'components/AdminNavBarItem'

interface NavItem {
  id: string
  name: string
  path: string
  component: React.ComponentType
}

const NAV_ITEMS: NavItem[] = [
  {
    id: 'merge',
    name: 'Merge NSCustomers',
    path: '/merge',
    component: MergeContainer,
  },
  {
    id: 'ssotool',
    name: 'SSO Tool',
    path: '/ssotool',
    component: SSOToolContainer,
  },
  {
    id: 'bulkassign',
    name: 'Bulk License Assignment',
    path: '/bulkassign',
    component: BulkAssignLayout,
  },
  {
    id: 'externalSiteMapping',
    name: 'External Site Mapping',
    path: '/externalSiteMapping',
    component: ExternalSiteMappingContainer,
  },
  {
    id: 'mergeSite',
    name: 'Merge Sites',
    path: '/mergeSite',
    component: MergeSiteContainer,
  },
  {
    id: 'sitePreferences',
    name: 'Site Preferences',
    path: '/sitePreferences',
    component: SitePreferencesContainer,
  },
  { id: 'pacing', name: 'Pacing', path: '/pacing', component: PacingContainer },
]

const UtilitiesLayout: React.FC = () => {
  const match = useRouteMatch()
  const basePath = match.path as string

  return (
    <>
      <Nav tabs>
        {NAV_ITEMS.map(item => (
          <AdminNavBarItem
            key={item.id}
            endpoint={`${basePath}${item.path}`}
            id={item.id}
            name={item.name}
          />
        ))}
      </Nav>
      <TabContent className="tab-content-bordered">
        <Switch>
          {NAV_ITEMS.map(item => (
            <Route
              key={item.id}
              component={item.component}
              path={`${basePath}${item.path}`}
            />
          ))}
          <Redirect exact from={basePath} to={`${basePath}/merge`} />
        </Switch>
      </TabContent>
    </>
  )
}

export default UtilitiesLayout
